import { createContext } from 'react';

const ModalContext = createContext({
  attachModal: (_) => {},
  detachModal: (_) => {},
  modalCallbacks: []
});

export default ModalContext;
